module.exports = __webpack_public_path__ + "img/m.138cfd2.png";